import fetch from '@/axios/promise';
import  {INVO_URL} from  '@/config/constant';
import qs from 'qs';

// 获取列表数据
export function page(query) {
  return invoke(query,'/getCmInvoRecordPage','POST');
}

// 获取合同开票数据
export function detailData(query) {
  return invoke(query,'/getCmInvoRecordData','POST');
}

// 获取人天服务合同的人天外包统计信息
export function getOutSourceData(query) {
  return invoke(query,'/getOutSourceData','POST');
}

// 更新合同开票记录数据
export function updateInvoRecordData(data) {
  return invoke(data,'/updateInvoRecordData','POST');
}

// 获取合同中的客户公司
export function getContCmp(query) {
  return invoke(query,'/getContCmpData','POST');
}

// 保存开票信息
export function saveInvoRecordInfo(data){
	return invoke2(data,'/saveInvoRecordInfo','POST');
}
// 流程提交
export function apprProcSubmit(query) {
  return invoke(query,'/apprProcSubmit','POST');
}
// 审批开票信息，数据处理
export function approveInvoRecord(data){
  return invoke(data,'/approveInvoRecord','POST');
}
//通过cpPlanId获取开票信息
export function getInvoInfoByCpPlanId(data) {
  return invoke(data,"/getInvoInfoByCpPlanId",'GET');
}
function invoke(query,url,method){
  return fetch({
    url: INVO_URL+url,
    method: method,
    params: query
  });
}

// 调用
// data 参数， 需要传递 format data 类型，或者后台 参数 添加 @RequestBody接收
//eg: let postData= new URLSearchParams()
//postData.append('param1',  value1)
//postData.append('param2',  value1)

function invoke2(data,url,method){
  // 需要转下
  data = qs.stringify(data);
  return fetch({
    url: INVO_URL+url,
    method: method,
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/api/cmInvo/contInvoice.js